<template>
  <svg
    width="280"
    height="180"
    viewBox="0 0 280 180"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M62.8303 132.93H176.1C176.74 132.93 177.37 132.86 177.97 132.73C178.57 132.86 179.2 132.93 179.84 132.93H244.57C249.38 132.93 253.28 129.03 253.28 124.22C253.28 119.41 249.38 115.51 244.57 115.51H237.1C232.29 115.51 228.39 111.61 228.39 106.8C228.39 101.99 232.29 98.0901 237.1 98.0901H260.75C265.56 98.0901 269.46 94.1901 269.46 89.3801C269.46 84.5701 265.56 80.6701 260.75 80.6701H233.37C238.18 80.6701 242.08 76.7701 242.08 71.9601C242.08 67.1501 238.18 63.2501 233.37 63.2501H153.71C158.52 63.2501 162.42 59.3501 162.42 54.5401C162.42 49.7301 158.52 45.8301 153.71 45.8301H82.7603C77.9503 45.8301 74.0503 49.7301 74.0503 54.5401C74.0503 59.3501 77.9503 63.2501 82.7603 63.2501H32.9703C28.1603 63.2501 24.2603 67.1501 24.2603 71.9601C24.2603 76.7701 28.1603 80.6701 32.9703 80.6701H64.0903C68.9003 80.6701 72.8003 84.5701 72.8003 89.3801C72.8003 94.1901 68.9003 98.0901 64.0903 98.0901H14.2803C9.47031 98.0901 5.57031 101.99 5.57031 106.8C5.57031 111.61 9.47031 115.51 14.2803 115.51H62.8303C58.0203 115.51 54.1203 119.41 54.1203 124.22C54.1203 129.03 58.0203 132.93 62.8303 132.93ZM265.72 132.93C270.53 132.93 274.43 129.03 274.43 124.22C274.43 119.41 270.53 115.51 265.72 115.51C260.91 115.51 257.01 119.41 257.01 124.22C257.01 129.03 260.91 132.93 265.72 132.93Z"
      fill="#F9FAFB"
    />
    <path
      d="M185.773 23.4054L93.9822 28.457C91.7764 28.5783 90.0867 30.4649 90.2081 32.6707L96.8202 152.819C96.9416 155.025 98.8282 156.714 101.034 156.593L192.825 151.541C195.031 151.42 196.721 149.534 196.599 147.328L189.987 27.1795C189.866 24.9737 187.979 23.284 185.773 23.4054Z"
      fill="white"
      stroke="#5359EA"
      stroke-width="2.5"
    />
    <path
      d="M176.839 33.8669L104.01 37.8749C101.804 37.9963 100.114 39.8829 100.235 42.0887L103.018 92.6422C103.139 94.848 105.026 96.5377 107.231 96.4163L180.061 92.4083C182.267 92.2869 183.957 90.4003 183.835 88.1945L181.053 37.641C180.932 35.4352 179.045 33.7455 176.839 33.8669Z"
      fill="#EFF2F8"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M105.57 105.56L156.38 102.77"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M139.23 111.83L177.07 109.75"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M105.83 113.67L131.34 112.27"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M106.23 121.03L177.48 117.12"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M108.1 144.94C112.29 143.74 120.45 136.75 116.93 131.55C114.22 127.55 109.91 134.76 110.68 137.58C111.89 142.01 118.63 143.89 122.59 143.28C127.92 142.45 132.96 136.22 138.31 137.19C141.81 137.82 143.67 141.44 147.59 140.42C150.52 139.65 152.23 136.56 155.25 135.84"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M166.909 89.4502C164.819 78.0902 154.569 69.7802 142.729 70.4302C130.889 71.0802 121.619 80.4602 120.779 91.9802"
      fill="white"
    />
    <path
      d="M166.909 89.4502C164.819 78.0902 154.569 69.7802 142.729 70.4302C130.889 71.0802 121.619 80.4602 120.779 91.9802"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M142.09 65.8903C148.403 65.8903 153.52 60.7729 153.52 54.4603C153.52 48.1477 148.403 43.0303 142.09 43.0303C135.778 43.0303 130.66 48.1477 130.66 54.4603C130.66 60.7729 135.778 65.8903 142.09 65.8903Z"
      fill="white"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M69.6103 56.3596C68.7003 54.0696 66.8803 52.2596 64.6003 51.3496L62.8203 50.6396L64.6003 49.9296C66.8903 49.0196 68.7003 47.1996 69.6103 44.9196L70.3203 43.1396L71.0303 44.9196C71.9403 47.2096 73.7603 49.0196 76.0403 49.9296L77.8203 50.6396L76.0403 51.3496C73.7503 52.2596 71.9403 54.0796 71.0303 56.3596L70.3203 58.1396L69.6103 56.3596Z"
      stroke="#A8B4F2"
      stroke-width="2.5"
      stroke-linejoin="round"
    />
    <path
      d="M215.61 134.36C214.7 132.07 212.88 130.26 210.6 129.35L208.82 128.64L210.6 127.93C212.89 127.02 214.7 125.2 215.61 122.92L216.32 121.14L217.03 122.92C217.94 125.21 219.76 127.02 222.04 127.93L223.82 128.64L222.04 129.35C219.75 130.26 217.94 132.08 217.03 134.36L216.32 136.14L215.61 134.36Z"
      stroke="#A8B4F2"
      stroke-width="2.5"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script setup>
</script>
